module.exports = __webpack_public_path__ + "static/media/star-rounded.81071254.svg";